import { Chip, createStyles, makeStyles, Paper } from "@material-ui/core";
import * as React from "react";

import {
    Attachment,
    AttachmentLinkCollection,
    DisplayField,
    domain,
    getUserFromStorage,
    RelodeTheme,
    Text,
} from "../..";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            paper: {
                padding: theme.spacing(2),
            },
            noPadding: {
                padding: theme.spacing(0),
                [theme.breakpoints.down("md")]: {
                    padding: theme.spacing(2),
                },
            },
            textBody: {
                padding: theme.spacing(0.5, 0, 2, 0),
                margin: 0,
                whiteSpace: "pre-line",
            },
            header: {
                marginBottom: 15,
            },
            chipRow: {
                padding: theme.spacing(1, 0),
                display: "flex",
                flexFlow: "row wrap",
                gap: 10,
            },
        }),
    { name: "JobOverview" }
);

interface JobOverviewProps {
    broadcastDescription: string;
    primaryPosition: domain.JobPosition;
    secondaryPositions: domain.JobPosition[];
    jobAttachments: Attachment[];
}

export const JobOverview = (props: JobOverviewProps) => {
    const {
        broadcastDescription,
        primaryPosition,
        secondaryPositions,
        jobAttachments,
    } = props;
    const classes = useStyles({});
    const user = getUserFromStorage();
    const isClient =
        user.role === domain.UserRole.Client ||
        user.role === domain.UserRole.ClientAdmin;

    return (
        <Paper elevation={isClient ? 0 : 1} className={isClient ? classes.noPadding : classes.paper}>
            <Text variant="h2" gutterBottom>
                overview
            </Text>
            <Text
                variant="body1"
                className={classes.textBody}
                dataCy="jobOverview-broadcastDescription-text"
            >
                {broadcastDescription?.length > 0
                    ? broadcastDescription
                    : "no broadcast description has been added"}
            </Text>
            {primaryPosition !== null || secondaryPositions.length > 0 ? (
                <>
                    <Text variant="subtitle2">job positions</Text>
                    <div className={classes.chipRow}>
                        {primaryPosition !== null ? (
                            <Chip
                                variant="outlined"
                                color="primary"
                                label={primaryPosition?.jobPositionName}
                            />
                        ) : null}
                        {secondaryPositions?.map(x => (
                            <Chip
                                variant="outlined"
                                color="primary"
                                label={x.jobPositionName}
                                key={x.jobPositionName}
                            />
                        ))}
                    </div>
                </>
            ) : null}
            {jobAttachments?.length ? (
                <div>
                    <Text variant="subtitle2">attachments</Text>
                    <DisplayField
                        label=""
                        component={
                            <AttachmentLinkCollection
                                id="details.attachments"
                                attachments={jobAttachments}
                            />
                        }
                    />
                </div>
            ) : null}
        </Paper>
    );
};
